import { forwardRef, useImperativeHandle } from "react";
import FormSelection from "../components/Form/FormSelection";
import { complainReasonMap } from "../lib/helper";
import { Complain } from "../models/complain.model";
import { useForm } from "react-hook-form";
import FormInputText from "../components/Form/FormInputText";

export const SurveyComplainSelectReasonForm = forwardRef(
  (props: { defaultValues?: Complain }, ref) => {
    const { control, setError, handleSubmit } = useForm({
      defaultValues: {
        reason: props.defaultValues?.reason,
      },
    });

    useImperativeHandle(ref, () => ({
      onSubmit: async () => {
        return new Promise((resolve, reject) => {
          handleSubmit(resolve, reject)();
        });
      },
    }));

    return (
      <div style={{ minWidth: 600 }}>
        <div style={{ marginTop: 16 }}>
          <FormSelection
            name="reason"
            label="Reason"
            required
            rules={{
              required: "Reason is required",
            }}
            options={Object.entries(complainReasonMap).map(([key, value]) => ({
              label: value,
              value: key,
            }))}
            control={control}
            setError={setError}
            noEmpty
          />
        </div>
      </div>
    );
  }
);

export const SurveyComplainAddNoteForm = forwardRef((_, ref) => {
  const { control, setError, handleSubmit } = useForm();

  useImperativeHandle(ref, () => ({
    onSubmit: async () => {
      return new Promise((resolve, reject) => {
        handleSubmit(resolve, reject)();
      });
    },
  }));

  return (
    <div>
      <div style={{ marginTop: 16 }}>
        <FormInputText
          name="details"
          label="Note"
          required
          rules={{
            required: "Note is required",
          }}
          control={control}
          setError={setError}
          multiline
          rows={3}
        />
      </div>
    </div>
  );
});
